import isEmpty from 'lodash/isEmpty'
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { Button, If, Text, Unless } from '../../../..'
import { setBuyerOnboardingAddress } from '../../../../../actions/buyerOnboarding'
import { createHome } from '../../../../../actions/homeCreate'
import { useTrackingContext } from '../../../../../providers/tracking'
import { selectBuyerOnboardingAddress } from '../../../../../store/selectors/buyerOnboarding'
import Autocomplete from '../../../../shared/Autocomplete'
import { IconCheckCircle } from '../../../../shared/Icon'
import { useWizardProvider } from '../../../../shared/WizardContext'
import { WizardButtonGroup } from '../Button'

import baseStyles from '../../BuyerOnboardingWizard.module.scss'
import styles from './EnterThinkingOfSellingHome.module.scss'

const EnterThinkingOfSellingHome = () => {
  const dispatch = useDispatch()
  const { trackingClient } = useTrackingContext()
  const buyerOnboardingAddress = useSelector(selectBuyerOnboardingAddress) || ''
  const { goBack, goForward } = useWizardProvider()
  const { fullAddress } = buyerOnboardingAddress

  const onAddressSelect = home => {
    trackingClient?.buyerOnboarded({ may_sell: home.fullAddress })
    dispatch(setBuyerOnboardingAddress(home))
    dispatch(createHome(home, false))
    goForward()
  }

  return (
    <div data-qa='thinking-of-selling-your-home' className={baseStyles.step}>
      <div>
        <Text.Headline>
          <FormattedMessage
            id='NewBuyerOnboarding.thinkingOfSelling.headline'
            defaultMessage='Thinking of selling your home?'
          />
        </Text.Headline>
        <Text size='s' variant='neutralCool' variantCount='600' align='center' className={styles.subheader}>
          <FormattedMessage
            id='NewBuyerOnboarding.thinkingOfSelling.subHeadline'
            defaultMessage='Enter your address and Homebot will estimate what you can afford to buy next.'
          />
        </Text>
        <Unless condition={isEmpty(buyerOnboardingAddress)}>
          <div className={styles.addressConfirmation}>
            <Text variant='success' variantCount='700' size='l' className={styles.checkIcon}>
              <IconCheckCircle />
            </Text>
            <Text size='s' variant='neutralCool' variantCount='900'>
              <FormattedMessage
                id='NewBuyerOnboarding.thinkingOfSelling.address.confirmation'
                defaultMessage='We successfully added {address}. You can change this later on.'
                values={{ address: fullAddress }}
              />
            </Text>
          </div>
        </Unless>
        <If condition={isEmpty(buyerOnboardingAddress)}>
          <Text size='m' align='center' variant='neutralCool' variantCount='900' className={styles.addText}>
            <FormattedMessage
              id='NewBuyerOnboarding.thinkingOfSelling.autocomplete'
              defaultMessage='Add your current home address:'
            />
          </Text>
          <Autocomplete className={styles.input} onSubmit={onAddressSelect} />
        </If>
      </div>
      <WizardButtonGroup>
        <Button.Back onClick={goBack} />
        <Unless condition={isEmpty(buyerOnboardingAddress)}>
          <Button.Forward onClick={goForward}>
            <FormattedMessage id='NewBuyerOnboarding.buttonGroup.continue' defaultMessage='Continue' />
          </Button.Forward>
        </Unless>
        <If condition={isEmpty(buyerOnboardingAddress)}>
          <Button.Forward onClick={goForward}>
            <FormattedMessage id='NewBuyerOnboarding.buttonGroup.skip' defaultMessage='Skip for now' />
          </Button.Forward>
        </If>
      </WizardButtonGroup>
    </div>
  )
}

export default EnterThinkingOfSellingHome
